module.exports = __webpack_public_path__ + "img/add-user.2e9ba2d8.svg";